export default function AnimaySaleStar(props) {
  return (
    <svg viewBox="0 0 355.6 280" style={{ enableBackground: "new 0 0 355.6 280" }} xmlSpace="preserve" {...props}>
      <path
        d="m175.6 35.4 53.1-26.5 21.3 47 62.9 3.4-17.7 47.7 48.7 31.9-49.8 30.1 15.9 48.3-63 1.1-23 46.2-52.1-28.4-53.1 26.5-21.2-47.1-63-3.4 17.7-47.6-48.7-32 49.9-30.1-15.9-48.3 63-1L123.5 7z"
      />
    </svg>
  );
}
